import axios from 'axios';
import { refreshAccessToken, logout } from './auth';

const debug = false;


const api = axios.create({
  baseURL: debug ? `http://localhost:8000/api/` : `https://api.alumni.uem.mz/api/`,
  //withCredentials: true, // Send cookies like refresh token
});

// Attach access token
api.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    // If token expired, try refresh once
    if (error.response?.status === 401 && !originalRequest._retry) {
      window.location.href = '/account/login';
      // originalRequest._retry = true;

      // try {
      //   const newAccess = await refreshAccessToken();
      //   localStorage.setItem('access_token', newAccess);
      //   originalRequest.headers.Authorization = `Bearer ${newAccess}`;
      //   return api(originalRequest);
      // } catch (refreshError) {
      //   logout();
      //   return Promise.reject(refreshError);
      // }
    }

    return Promise.reject(error);
  }
);

export default api;
